import React            from 'react';

import { Text } from '../Text/Text';
import classNames from 'classnames';
import styles from './Dropdown.css';
import CustomLink from '../RedirectLink/RedirectLink';

type DropdownProps = {
    link?: any;
    title?: any;
    absolute?: boolean;
    noHover?: boolean;
    onClick?: any;
    index?: number;
    text?: string;
};

export class DropdownItem extends React.PureComponent<DropdownProps> {
    preventClick(e) {
        e.stopPropagation();
        e.preventDefault();
        if (this.props.onClick) {
            this.props.onClick();
        }
    }

    render() {
        const { link, title, absolute, noHover, text, index} = this.props;
        const linkText = <LinkText>{title}</LinkText>;

        return (
            !link ? (
                <ListItem
                    data-element-description = {this.props['data-element-description']}
                    onClick = {this.preventClick}
                    inactive = {noHover}
                >
                    {this.props.children}
                </ListItem>
            ) : (
                <ListItem data-element-description = {this.props['data-element-description']}>
                    {
                        absolute
                            ? <A target="_blank" rel = "noopener" href = {link}>{linkText}</A>
                            : <CustomLink to = {link} onClick = {() => this.props.onClick(text, index + 1)} className={styles.link}>
                                {linkText}
                             </CustomLink>
                    }
                </ListItem>
            )
        );
    }
}

const ListItem = ({ inactive, ...props}: any) => (
    <li className = {classNames(styles.listItem, {[styles.inactive]: inactive})} {...props} />
);
const LinkText = (props: any) => <Text className = {styles.linkText} {...props} />;
const A = (props: any) => <a className = {styles.link} {...props} />;
